import { Column } from '@/components/container/Container';
import { OnboardingStep } from '@/types';
import { TextBodyMedium, TextHeadlineExtraLarge } from '@/components/text/Texts';
import { Button } from 'primereact/button';
import { useOnboardingState } from '../engine/onboarding.hooks';

const OnboardingFinishScreen = () => {
	const { completeStepMutation } = useOnboardingState();

	return (
		<Column className="h-screen max-w-[1000px] gap-8 mx-auto p-6 justify-center items-center">
			<TextHeadlineExtraLarge
				className="text-black"
				text="You’re All Set to Use Xpress for Business"
			/>
			<TextBodyMedium
				className="text-neutral17"
				text="Congratulations on completing your account setup! You’re now ready to start using Xpress for Business and enjoy the convenience and efficiency it offers. Your 30-day trial period begins now, so feel free to explore all the features and benefits without any charges. Should you need any assistance, our support team is here to help. Enjoy your seamless business travel and management experience with Xpress for Business!"
			/>
			<Button
				label="Go to Home"
				className="w-[260px] h-12 bg-primary rounded-[100px] text-label-large2 text-white"
				onClick={() => completeStepMutation.mutate(OnboardingStep.Finished)}
			/>
		</Column>
	);
}

export default OnboardingFinishScreen;
